import React, { Component } from 'react';
import DetalleImg from '../images/banner.png'

import '../styles/Landing.css';
import * as urlLogin from '../config/urlLogins.js';
import Analytics from './Analytics'
import ScrollTop from './ScrollTop'

class Landing extends Component {
    openNewTab(url){
        window.open(url);
    }
    render() {
        return(
            <div className="Detalle">
                <ScrollTop />
                <Analytics />
                <div class="detalle-container">
                    <img src={DetalleImg} class="banner-detalle"/>
                    <div class="detalle-title-container">
                        <h4 class="detalle-title">¿Por qué elegirnos?</h4>
                    </div>
                         <div class="detalle-square-img-container">
                            <div class="text-square text-square-first">
                                <h3>FARMACIAS</h3>
                                <ul>
                                    <li>Solicite su usuario haciendo click <a target="_blank" rel="noopener noreferrer" href="https://mobile.globalfarm.com.ar:8281/users/register?from=TRANSFER"><b>aquí</b></a> e ingrese sus transfers directamente desde la web</li>
                                    <li class="li-color-detalle"><p>Si ya posee una cuenta habilitada ingrese directamente con su USUARIO presionando el botón TRANSFER</p></li>
                                
                                </ul>
                                <button class="detalle-text-button" onClick={() => this.openNewTab(urlLogin.TRANSFERS)}>TRANSFER</button>
                            </div>
                        </div>
                    </div>
                </div>

        );
    }
}

export default Landing


// WEBPACK FOOTER //
// ./src/components/Landing.js